export interface AutoCompleteSearchInputActionEvent {
  text: string;
  type: AutoCompleteActionEventType;
}

export enum AutoCompleteActionEventType {
  focus = 'focus',
  typing = 'typing',
}
